import React, {useMemo} from "react"
import {useParams} from "react-router-dom";
import {Layout} from "../Layout";
import LoadingSpinner from "../../../components/ui/LoadingSpinner";
import {ErrorMessage} from "../ErrorMessage";
import {useGetSirenMessageContent} from "../hooks/useGetSirenMessageContent";
import {SirenMessageContentForm} from "./SirenMessageContentForm";

export function SirenMessageContentEdit() {
    const {id} = useParams();
    const {data, isLoading, error} = useGetSirenMessageContent(id);

    const content = useMemo(() => {
        if (data) return <SirenMessageContentForm item={data} mode="edit"/>
        if (error) return <ErrorMessage text="error loading message content"/>
        if (isLoading) return <div className="flex justify-center p-8"><LoadingSpinner/></div>
    }, [data, isLoading, error])

    return (
        <Layout menuCurrent="message-contents">
            {content}
        </Layout>
    )
}
